module.exports = __webpack_public_path__ + "img/22.dc6201bc.png";